import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 0C4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754S17.1 0 11 0m0 19.551c-5 0-9-3.91-9-8.798s4-8.798 9-8.798 9 3.91 9 8.798-4 8.798-9 8.798m4-9.776h-3V6.843c0-.587-.4-.978-1-.978s-1 .391-1 .978v2.932H7c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978h3v2.932c0 .587.4.978 1 .978s1-.391 1-.978v-2.932h3c.6 0 1-.391 1-.978 0-.586-.4-.978-1-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }